import './styles/JobType.scss';

import { EuroSymbol } from '@mui/icons-material';
import { Grid, Paper, Modal } from '@mui/material';
import { JobType as JobTypeType } from '@thro-types/jobmarket';

import clsx from 'clsx';
import { useState } from 'react';

import TypeDetail from './TypeDetail';

interface Props {
  type: JobTypeType;
}

export default function JobType({ type }: Props) {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <>
      <Grid
        container
        className={clsx('job-type', { 'job-type--paid': type.paid })}
        component={Paper}
        elevation={3}
        justifyContent="space-between"
        onClick={() => setModalOpen(true)}
      >
        <Grid item xs className="job-type__name">
          {type.name}
        </Grid>
        {type.paid && (
          <Grid item xs="auto" className="job-type__icon">
            <EuroSymbol />
          </Grid>
        )}
      </Grid>
      <Modal
        className="type-detail-modal"
        open={modalOpen}
        onClose={(props, reason) => {
          if (reason && reason === 'backdropClick') return;
          setModalOpen(false);
        }}
      >
        <Grid item component={Paper} elevation={5} className="type-detail-modal__body">
          <TypeDetail typeId={type.id} closeHandler={() => setModalOpen(false)} />
        </Grid>
      </Modal>
    </>
  );
}
